import { AuthApi, FeatureToggleApi, SettingsApi } from 'vrlcm-gui-api';
import { FeatureKey } from 'vrlcm-gui-types';
import init from './esp-init';

declare const esp: ESP;

async function identify(userId: string, data?: object) {
  const api = new Promise(resolve => {
    esp.identify(userId, data, resolve);
  });

  try {
    await api;
    return true;
  } catch (e) {
    /* eslint-disable no-console */
    console.debug('Failed to contact ESP', e);
    return false;
  }
}

// public functions

async function espIdentifyUser() {
  try {
    const enabled = await FeatureToggleApi.isFeatureEnabled(
      FeatureKey.InProductFeedback
    );
    if (enabled) {
      const telemetryInfo = await SettingsApi.getTelemetryInformation();
      const systemInfo = await SettingsApi.getSystemInformation();
      const { collectorInstanceId } = telemetryInfo;
      const { buildNumber, version } = systemInfo;
      const { user } = await AuthApi.getUserData();
      if (user) {
        return await identify(`${collectorInstanceId}/${user.name}`, {
          ...user,
          collectorInstanceId,
          buildNumber,
          version
        });
      }
    }
  } catch (e) {
    /* eslint-disable no-console */
    console.debug('espIdentifyUser failed', e);
    return false;
  }

  return false;
}

async function espInit() {
  const enabled = await FeatureToggleApi.isFeatureEnabled(
    FeatureKey.InProductFeedback
  );
  if (enabled) {
    init();
  }
}

export { espInit, espIdentifyUser };
